/* eslint-disable class-methods-use-this */
// @flow
import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet-async';
import { Container } from '@finect/tabular-core/Container';
import { ContainerInner } from '@finect/tabular-core/ContainerInner';
import { MainContent } from '@finect/tabular-core/MainContent';
import { H1 } from '@finect/tabular-core/Headings';
import { Button } from '@finect/tabular-core/Button';
import { Datalayer } from '@finect/front-gtm';
import imported from 'react-imported-component';
import type { ProfessionalType } from '../../types';

const Section = imported(() =>
  import(/* webpackChunkName: "TC-Section" */ '@finect/tabular-components/Section').then(module => module.Section));

type Props = {
  staticContext?: Object,
  history: Object,
  location: Object,
  toggleModal: Function
};

type State = {
  professionals: Array<ProfessionalType>
};

export class Faq extends React.Component<Props, State> {

  state =
    typeof window === 'undefined'
      ? {
        professionals: this.props.staticContext ? this.props.staticContext.initialData.professionals : []
      }
      : {
        professionals: (window.initialData && window.initialData.professionals) || []
      };

  // componentDidMount() {
  // }

  redirectTo = (url: string) => {
    this.props.history.push(url);
  };

  startOnboarding = () => {
    document.location.href =
      // eslint-disable-next-line max-len
      'https://login.finect.com?next=https://www.finect.com/usuario/configuracion/request';
  };

  // static loadInitialData() {
  // }

  render() {
    return (
      <Fragment>
        <Helmet>
          <title>Preguntas frecuentes - Finect Asesores</title>
          <meta name="description" content="Asesores financieros en Finect" />
          <meta name="robots" content="noindex, follow" />
          <link rel="canonical" href={`https://${process.env.FINECT_BASEURL || 'www.finect.com'}/asesores/faq`} />
        </Helmet>

        <Datalayer id="Scene" type="ready" params={{ pageType: 'advisersProfessionals' }} />
        <Datalayer id="Scene" type="pageType" params={{ pageType: 'advisersProfessionals' }} />
        <Container>
          <ContainerInner>
            <MainContent>
              <H1>Preguntas más frecuentes</H1>

              <p>¿Cuál es el precio del servicio?</p>

              <p>¿Cómo respondo preguntas?</p>

              <p>¿Cómo escribo reviews?</p>

              <p>¿Cómo escribo artículos para que salgan en Finect?</p>

              <p>¿Cuántos leads voy a recibir al mes?</p>
              <p>¿Cómo puedo ver los leads?</p>
              <p>¿Cómo sé que tengo nuevos leads?</p>
              <p>¿Qué ocurre si no contacto con el lead?</p>

              <p>¿Cómo me comunico con los usuarios?</p>
              <p>¿Cómo me pongo en contacto con ellos?</p>

              <p>¿Cuál es el precio del servicio?</p>

              <p>¿Es un contrato anual o mensual?</p>

              <p>¿Cuándo y cómo puedo darme de baja?</p>

              <p>¿Cómo se hace el pago?</p>

              <p>¿Qué requisitos necesito para darme de alta?</p>

              <Section title={'¿Cómo me doy de alta?'} topMargin bottomMargin>
                <Button variant="medium" width="auto" onClick={() => this.startOnboarding()}>
                  Empezar
                </Button>
              </Section>
            </MainContent>
          </ContainerInner>
        </Container>
      </Fragment>
    );
  }
}
